import './assets/app.css';

import { createApp } from 'vue';
import * as Sentry from '@sentry/vue';
import App from './App.vue';
import router from './router';
import { MotionPlugin } from '@vueuse/motion';

const app = createApp(App);

app.provide('appLoginUrl', import.meta.env.VITE_APP_LOGIN_URL);
app.provide('appSignupUrl', import.meta.env.VITE_APP_SIGNUP_URL);

if (import.meta.env.VITE_SENTRY_ENV === 'production') {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      })
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.5,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/orqui\.ai/],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
}

app.use(router);
app.use(MotionPlugin);
app.mount('#app');
